// Account-aware feature flags (Aug 20).
//
// The social + scheduling surface (FB/IG publish/connect/analytics + Ad
// Calendar/Pilot) is globally hidden for real users while Meta App Review is
// pending (see config/featureFlags.ts), but turned ON for the Meta reviewer +
// the internal team via an email allowlist. These hooks read the current
// signed-in user and return the per-account boolean, so components just do:
//
//   const socialEnabled = useSocialPublishingEnabled();
//   {socialEnabled && <PublishButton />}
//
// After Meta approves, flip the two globals to true and these become no-ops.

import { useAuth } from './useAuth';
import {
  socialPublishingEnabledForEmail,
  schedulingEnabledForEmail,
} from '@/config/featureFlags';

export function useSocialPublishingEnabled(): boolean {
  const { user } = useAuth();
  return socialPublishingEnabledForEmail(user?.email);
}

export function useSchedulingEnabled(): boolean {
  const { user } = useAuth();
  return schedulingEnabledForEmail(user?.email);
}
